import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import logo from '../../space.webp';
import userIcon from './../../img/userIcon.png';
import Cookies from 'universal-cookie';
import './personInfo.css';
import PersonModel from '../models/PersonModel';
import SearchModel from '../models/SearchModel';
import loading from '../../img/loading.gif';
import persons from '../../img/profile.png';
import print from '../../img/print.png'
import edit from '../../img/edit.png'
import trash from '../../img/trash.png'
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { Buffer } from 'buffer'
import { createAddress, createPersonCollapsed, createTraitorCollapsed, 
    createAddressCollapsed, createAutoCollapsed, createCompanyCollapsed, createContactCollapsed, 
    createGunCollapsed, createDocCollapsed, createArchCollapsed, createOPMCollapsed, createBSCollapsed, createKanCollapsed, 
    showError} from '../ViewCreator';


const cookies = new Cookies();
function AddressInfo() {

    const [type, setType] = useState(0);

    const mainSubmit = () => {
        window.location.href = "/main";
    };


    useEffect(() => {
        if (cookies.get('type') != null) {
            var t = cookies.get('type')
            setType(t);
        }


        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get("id");
        sendAddress(id);
    }, []);

    const setViews = (inner) => {
        var a = document.getElementById("viewFull");
        a.innerHTML = ""
        for (let index = 0; index < inner.length; index++) {
            a.appendChild(inner[index])
        }
    }

    const sendAddress = (id) => {
        var path = ip + '/api/address/info';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                    var zz = []
                
                    var pers = result.data
                var pe =  createAddress(pers)
                zz.push(pe)

                if (pers.photos.length > 0) {
                    var adr = document.createElement('div');
                    adr.innerHTML = "<br><hr>Фото:";
                    zz.push(adr)
                    var inner = document.createElement('div');
                    inner.className = 'prevInner'
                    for (let index = 0; index < pers.photos.length; index++) {
                        var d = document.createElement('div');


                        if (pers.image === '' + pers.photos[index].id) {
                            d.className = 'prevViewSelected'
                        } else {
                            d.className = 'prevView'



                            var b = document.createElement('Button');
                            b.className = "buttonImage"
                            b.textContent = "Зробити головною"

                            const cl = i => () => {
                                sendAvatar(pers.id, i)
                            }

                            b.onclick = cl(pers.photos[index].id)



                            d.appendChild(b)
                        }


                        var element = new Image();
                        //element.src = 'data:image/png;base64,'+pers.photos[index].image

                        //element.className = 'prevImage'

                        element.src = loading
                        element.className = 'prevImageSearchEmpty'
                        element.id = 'image' + pers.photos[index].id



                        getAvatar(pers.photos[index].id, 'prevImage')





                        //element.src = 'data:image/png;base64,'+pers.image
                        //element.className = 'prevImageSearch'




                        d.appendChild(element)
                        //img.source = {uri: base64Image}

                        if (pers.photos[index].text != undefined) {
                            var t = document.createElement('div');

                            t.innerHTML = pers.photos[index].text
                            d.appendChild(t)
                        }
                        inner.appendChild(d)
                        const dblcl = i => () => {
                            var d = window.open().document;
                            d.write(''); d.close();
                            d.body.appendChild(document.createElement('img')).src = 'data:image/png;base64,' + pers.photos[index].image;


                        }
                        d.ondblclick = dblcl(0)
                    }

                    zz.push(inner)
                }


                if (pers.persons.length > 0) {
                                        var adr = document.createElement('div');
                                        adr.innerHTML = "<br><hr>Зв'язки:";
                                        zz.push(adr)
                                        for (let index = 0; index < pers.persons.length; index++) {
                                            var a = createPersonCollapsed(pers.persons[index].person, index, pers.persons[index].type, pers.persons[index].text, "Р", "П");
                                            var i = pers.persons[index].person.id
                                            const dblcl = i => () => {
                                                sendPersonFullScreen(i)
                                            }
                                            a.ondblclick = dblcl(pers.persons[index].person.id)
                                            zz.push(a)
                
                                        }
                                    }

                if(pers.auto.length>0){
                                                      var adr = document.createElement('div');
                                                      adr.innerHTML = "<br><hr>Транспорт:";
                                                      zz.push(adr)
                                                      for (let index = 0; index < pers.auto.length; index++) {
                                                        var a = createAutoCollapsed(pers.auto[index].auto,index,pers.auto[index].type,pers.auto[index].text, "П", "Т");
                                                          zz.push(a)
                                                          var i = pers.auto[index].auto.id
                                                          const dblcl = i => () =>{
                                                            sendAutoFullScreen(i)
                                                        }
                                                        a.ondblclick = dblcl(pers.auto[index].auto.id)
                                                          zz.push(a)
                                                      }
                                                    }

               if(pers.company.length>0){
                                                     var adr = document.createElement('div');
                                                     adr.innerHTML = "<br><hr>Компанії:";
                                                     zz.push(adr)
                                                     for (let index = 0; index < pers.company.length; index++) {
                                                         var a = createCompanyCollapsed(pers.company[index].company,index, "Р", "В");
                                                         //zz.push(a)
                                                         var i = pers.company[index].company.id
                                                         const dblcl = i => () =>{
                                                           sendCompanyFullScreen(i)
                                                       }
                                                       a.ondblclick = dblcl(pers.company[index].company.id)
                                                         zz.push(a)
                                                     }
                                                   }

                if(pers.opms.length>0){
                                                      var opm = document.createElement('div');
                                                      opm.innerHTML = "<br><hr>Заходи:";
                                                      zz.push(opm)
                                                      for (let index = 0; index < pers.opms.length; index++) {
                                                        var a = createOPMCollapsed(pers.opms[index].opm,index,pers.opms[index].type,pers.opms[index].text, "О", "#");
                                                          zz.push(a)
                                                          var i = pers.opms[index].opm.id
                                                          const dblcl = i => () =>{
                                                            sendOPMFullScreen(i)
                                                        }
                                                        a.ondblclick = dblcl(pers.opms[index].opm.id)
                                                          zz.push(a)
                                                      }
                                                    }

               if(pers.contacts.length>0){
                                                     var adr = document.createElement('div');
                                                     adr.innerHTML = "<br><hr>Контакти:";
                                                     zz.push(adr)
                                                     for (let index = 0; index < pers.contacts.length; index++) {
                                                         var a = createContactCollapsed(pers.contacts[index], "З", "О"); zz.push(a)
                                                         var i = pers.contacts[index].idContact
                                                         const dblcl = i => () =>{
                                                           sendContactFullScreen(i)
                                                         }
                                                         a.ondblclick = dblcl(pers.contacts[index].idContact)
                                                         zz.push(a)
                                                     }
                                                   }

                if(pers.arch.length>0){
                                                      var adr = document.createElement('div');
                                                      adr.innerHTML = "<br><hr>Файли:";
                                                      zz.push(adr)
                                                      for (let index = 0; index < pers.arch.length; index++) {
                                                          var a = createArchCollapsed(pers.arch[index],index);
                                                          
                                                          var b = document.createElement('Button');
                                                          b.className = "buttonDownload"
                                                          b.textContent = "Завантажити"
                                    
                                                          const cl = i => () =>{
                                                            getFile(i.id,i.fileName)
                                                            //pp(i)
                                                          }
                                                          
                                                          b.onclick = cl(pers.arch[index].archive)
                                    
                                    
                                    
                                                          a.appendChild(b)
                                                          zz.push(a)
                                                      }
                                                    }


                                                    String.prototype.replaceAt = function (index, replacement) {
                                                        return this.substr(0, index) + replacement + this.substr(index + replacement.length);
                                                    }
                                                    if (pers.infoAddress != undefined) {
                                                    var spr = document.createElement('div');
                                                    spr.className = "spravka"
                                
                                                    spr.innerHTML = "<hr><p>" + pers.infoAddress.replace(/\r\n/g, "<p>");
                                                    zz.push(spr)
                                                    }
                                                    setViews(zz)

                
              



                
               if (pers.persons.length > 0) {
                                       for (let index = 0; index < pers.persons.length; index++) {
                                           if (pers.persons[index].person.image != undefined) {
                                               getAvatar(pers.persons[index].person.image, 'prevImageSearch')
                                           }
                                       }
                                   }

                }
            })
    }

    const sendPersonFullScreen = (id) => {
        window.open("/person?id=" + id)
    }
      const sendAutoFullScreen = (id) => {
        window.open("/auto?id="+id)
      }
      const  sendCompanyFullScreen = (id) => {
        window.open("/company?id="+id)
      }
      const  sendContactFullScreen = (id) => {
        window.open("/contact?id="+id)
      }
      const  sendOPMFullScreen = (id) => {
        window.open("/opm?id="+id)
      }
      const  sendDocFullScreen = (id) => {
        window.open("/document?id="+id)
      }
      const  sendGunFullScreen = (id) => {
        window.open("/gun?id="+id)
      }
      
      const sendKanFullScreen = (id) => {
        window.open("/kan?id="+id)
      }

    const sendAvatar = (id, idPhoto) => {
        var path = ip + '/api/person/avatar';
        var ss = "{\"id\":" + id + ", \"idPhoto\":" + idPhoto + "}"
        var bd = encryptAes(ss)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                sendAddress(id)
            }
            )
    }

    const getAvatar = async (id) => {
        var path = ip + '/files/avatar';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);


                    var a = document.getElementById('image' + id)
                    a.src = 'data:image/png;base64,' + result.data
                    a.className = 'prevImageSearch'
                }
            })

    }

    const getFile = async(id, fileName) => {
        var path = ip+'/files/file';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);

                    var byteArray = Buffer.from(result.data, "base64"); 
        
                    const blob = new Blob([byteArray],{ type: 'application/octet-binary' });
                    
                                        const link = document.createElement('a');
                                        // Browsers that support HTML5 download attribute
                                        if (link.download !== undefined) {
                                          const url = URL.createObjectURL(blob);
                                          link.setAttribute('href', url);
                                          link.setAttribute('download', fileName);
                                          link.style.visibility = 'hidden';
                                          document.body.appendChild(link);
                                          link.click();
                                          document.body.removeChild(link);
                                        }
                }
            })
      }

    const printSubmit = () => {

    }

    const editSubmit = () => {
            const queryParams = new URLSearchParams(window.location.search)
            const id = queryParams.get("id");
            window.open("/edit/address?id="+id, "_self")
        }
    
        const trashSubmit = () => {
            Swal.fire({
                title: 'Ви дійсно бажаєте видалити запис',
                //text: "Оновити інформацію?",
                icon: 'question',
                html:
                    '',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: 'Видалити',
                denyButtonText: 'Оновити',
    
                background: '#2B2B2B',
                color: '#FFF'
            }).then((result) => {
                if (result.isConfirmed) {
                    removePerson()
                }
            })
        }
    
        const removePerson = () => {
            const queryParams = new URLSearchParams(window.location.search)
            const id = queryParams.get("id");
            var path = ip + '/api/address/remove';
            var bd = encryptAes((id))
            const requestOptions = {
              headers: {
                'Content-Type': 'Content-type: text/html'
              },
              credentials: 'include',
              uri: path,
              encoding: 'latin1',
              body: bd,
              method: 'POST'
            };
            fetch(path, requestOptions)
              .then()
              .then(response => { return response.arrayBuffer() })
              .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                  var result = JSON.parse(text);
                  showError(result.msg)
        
                } catch (error) {
                  const decryptedText = decryptAes(text);
                  var result = JSON.parse(decryptedText);
                  storeKey('test_data', result.key);
                  Swal.fire({title: 'Видалено', text: '', icon: 'success', timer: 5000 ,background: '#2B2B2B',
                    color: '#FFF',
                    didClose: (toast) => {
                      window.open("/main","_self")
                    }})
                  
                }
              })
          }

    return (
        <div className="main">
            <div className="header">
                <img src={logo} className="logo" alt="logo" />
                <div className="title" onClick={mainSubmit}>SPACE</div>
                <div className="subtitle">(info) </div>

                <button className="headerButton" onClick={printSubmit} >
                    <img src={print} className="headerImage" />
                </button>
                <button className="headerButton" hidden={type > 2} onClick={editSubmit} >
                    <img src={edit} className="headerImage" />
                </button>
                <button className="headerButton" hidden={type > 1} onClick={trashSubmit} >
                    <img src={trash} className="headerImage" />
                </button>

            </div>


            <div id="viewFull">

            </div>
        </div>
    );
}


export default AddressInfo;